// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * The canonical styling for rendered markdown — anything produced by
 * markdownToSafeHtml. Add \`markdown-content\` to the container you inject
 * into and the output reads like a document.
 *
 * These rules are the wiki's (previously .wiki-rendered), promoted to the
 * shared home because that surface had the most complete and best-looking
 * set. Every other markdown surface had grown its own partial copy, so each
 * new surface silently reintroduced the same defects — most visibly lists,
 * which arrive bullet-less and oversized.
 *
 * Two global rules in App.css are what these undo:
 *   ul { list-style-type: none; padding: 0 }
 *   li { margin: .5rem 0; font-size: 1.1rem; color: var(--secondary-text-color) }
 * They were written for nav and marketing lists; injected markdown inherits
 * them, so a model's bullet list renders as bullet-less, oversized, washed-out
 * lines that read as a broken typographic style rather than a list.
 */

.markdown-content img,
.markdown-content video {
  max-width: 100%;
}

.markdown-content ul {
  list-style-type: disc;
  padding-left: 1.6em;
  margin: 0.5em 0;
}

.markdown-content ol {
  list-style-type: decimal;
  padding-left: 1.6em;
  margin: 0.5em 0;
}

.markdown-content ul ul,
.markdown-content ol ul {
  list-style-type: circle;
}

/* Inherit the container's type scale and colour: the global reset above is
   nav chrome, and markdown body text should read as body text. */
.markdown-content li {
  margin: 0.15em 0;
  font-size: inherit;
  color: inherit;
}

/* GFM task lists: the app's global input rule stretches inputs full-width —
   keep the checkbox inline with its label. */
.markdown-content li input[type='checkbox'] {
  width: auto;
  display: inline-block;
  margin: 0 6px 0 0;
  vertical-align: middle;
}

.markdown-content li:has(> input[type='checkbox']) {
  list-style: none;
  margin-left: -1.2em;
}

.markdown-content table {
  border-collapse: collapse;
  margin: 0.8em 0;
  display: block;
  max-width: 100%;
  overflow-x: auto;
}

.markdown-content th,
.markdown-content td {
  border: 1px solid var(--border-color);
  padding: 6px 12px;
  text-align: left;
}

.markdown-content th {
  background: var(--card-background);
  font-weight: 600;
}

.markdown-content blockquote {
  border-left: 3px solid var(--border-color);
  margin: 0.8em 0;
  padding: 2px 14px;
  color: var(--secondary-text-color);
}

.markdown-content pre {
  background: var(--card-background);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  padding: 10px 12px;
  overflow-x: auto;
}

.markdown-content code {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.92em;
  background: var(--card-background);
  border-radius: var(--radius-sm);
  padding: 1px 4px;
}

.markdown-content pre code {
  background: none;
  padding: 0;
}

.markdown-content hr {
  border: none;
  border-top: 1px solid var(--border-color);
  margin: 1.2em 0;
}
`, "",{"version":3,"sources":["webpack://./src/markdown-content.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;EAiBE;;AAEF;;EAEE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;iEACiE;AACjE;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;6CAC6C;AAC7C;EACE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,eAAe;EACf,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2DAA2D;EAC3D,iBAAiB;EACjB,kCAAkC;EAClC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,yCAAyC;EACzC,eAAe;AACjB","sourcesContent":["/*\n * The canonical styling for rendered markdown — anything produced by\n * markdownToSafeHtml. Add `markdown-content` to the container you inject\n * into and the output reads like a document.\n *\n * These rules are the wiki's (previously .wiki-rendered), promoted to the\n * shared home because that surface had the most complete and best-looking\n * set. Every other markdown surface had grown its own partial copy, so each\n * new surface silently reintroduced the same defects — most visibly lists,\n * which arrive bullet-less and oversized.\n *\n * Two global rules in App.css are what these undo:\n *   ul { list-style-type: none; padding: 0 }\n *   li { margin: .5rem 0; font-size: 1.1rem; color: var(--secondary-text-color) }\n * They were written for nav and marketing lists; injected markdown inherits\n * them, so a model's bullet list renders as bullet-less, oversized, washed-out\n * lines that read as a broken typographic style rather than a list.\n */\n\n.markdown-content img,\n.markdown-content video {\n  max-width: 100%;\n}\n\n.markdown-content ul {\n  list-style-type: disc;\n  padding-left: 1.6em;\n  margin: 0.5em 0;\n}\n\n.markdown-content ol {\n  list-style-type: decimal;\n  padding-left: 1.6em;\n  margin: 0.5em 0;\n}\n\n.markdown-content ul ul,\n.markdown-content ol ul {\n  list-style-type: circle;\n}\n\n/* Inherit the container's type scale and colour: the global reset above is\n   nav chrome, and markdown body text should read as body text. */\n.markdown-content li {\n  margin: 0.15em 0;\n  font-size: inherit;\n  color: inherit;\n}\n\n/* GFM task lists: the app's global input rule stretches inputs full-width —\n   keep the checkbox inline with its label. */\n.markdown-content li input[type='checkbox'] {\n  width: auto;\n  display: inline-block;\n  margin: 0 6px 0 0;\n  vertical-align: middle;\n}\n\n.markdown-content li:has(> input[type='checkbox']) {\n  list-style: none;\n  margin-left: -1.2em;\n}\n\n.markdown-content table {\n  border-collapse: collapse;\n  margin: 0.8em 0;\n  display: block;\n  max-width: 100%;\n  overflow-x: auto;\n}\n\n.markdown-content th,\n.markdown-content td {\n  border: 1px solid var(--border-color);\n  padding: 6px 12px;\n  text-align: left;\n}\n\n.markdown-content th {\n  background: var(--card-background);\n  font-weight: 600;\n}\n\n.markdown-content blockquote {\n  border-left: 3px solid var(--border-color);\n  margin: 0.8em 0;\n  padding: 2px 14px;\n  color: var(--secondary-text-color);\n}\n\n.markdown-content pre {\n  background: var(--card-background);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  padding: 10px 12px;\n  overflow-x: auto;\n}\n\n.markdown-content code {\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 0.92em;\n  background: var(--card-background);\n  border-radius: var(--radius-sm);\n  padding: 1px 4px;\n}\n\n.markdown-content pre code {\n  background: none;\n  padding: 0;\n}\n\n.markdown-content hr {\n  border: none;\n  border-top: 1px solid var(--border-color);\n  margin: 1.2em 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
